// src/lib/studentEmail.js — academic-email check for the student trial.
// KEEP IN SYNC with api/lib/student.php (is_student_email) — same regex.
export const STUDENT_EMAIL_RE = /[.@](edu|edu\.[a-z]{2,3}|ac\.[a-z]{2,3})$/i;

export const isStudentEmail = (email) =>
    STUDENT_EMAIL_RE.test(String(email || '').trim());
